<template>
    <div class="vue-need-bootstrap h100">
        <div class="d-flex justify-content-center w-100 h-100 overflow-auto">
            <div class="d-flex flex-column h-100 w-100" :class="{ 'mb-3': breadcrumbItems.length }">
                <b-breadcrumb v-if="breadcrumbItems.length" :items="breadcrumbItems" />
                <c-loader v-model="loader.value" :text="loader.text" />
                <div class="app-container mt-3 d-flex flex-grow-1">
                    <transition name="fade" mode="out-in">
                        <router-view />
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- TODO: transform this wrapper into app.vue -->
<script lang="ts" setup>
import { computed, provide } from 'vue';
import { useRoute } from 'vue-router/composables';
import store from '@/store';
import { ANGULAR_BRIDGE } from '@/composables/useAngularBridge';
import CLoader from '@/components/shared/CLoader.vue';

interface BreadcrumbItem {
    name: string;
    href: string;
    link?: string;
}

// Handled by VueRouterWrapperCtrl through the ng-vue v-on-* bindings
const emit = defineEmits<{
    (event: 'navigate', url: string, replace?: boolean): void;
    (event: 'create-template'): void;
    (event: 'edit-template', templateId: string): void;
}>();

provide(ANGULAR_BRIDGE, {
    navigate: (url, replace) => emit('navigate', url, replace),
    createTemplate: () => emit('create-template'),
    editTemplate: (templateId) => emit('edit-template', templateId)
});

const route = useRoute();

const breadcrumbItems = computed(() => {
    const breadcrumbs: BreadcrumbItem[] = route.meta?.breadcrumb || [];
    return breadcrumbs.map((b) => ({
        to: b.link,
        text: b.name,
        href: b.href
    }));
});

const loader = computed(() => {
    const state = store.state.loader;
    return {
        value: state.active,
        text: state.text
    };
});
</script>
